import { useEffect } from 'react';
import { Alert, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Balance from '../../components/Balance';
import BottomNavigationBar from '../../components/BottomNavigationBar';
import GoalsSection from '../../components/GoalsSection';
import UserPageHeader from '../../components/UserPageHeader';
import useGoalsStore from '../../store/goals';
import useGroupStore from '../../store/group';
import useUserStore from '../../store/user';

export default function HomePage() {
  const balance = useUserStore(state => state.balance);
  const isLoading = useUserStore(state => state.isLoading);
  const error = useUserStore(state => state.error);
  const updateBalance = useUserStore(state => state.updateBalance);
  const { t } = useTranslation();

  const goals = useGoalsStore(state => state.goals);
  const goalsLoading = useGoalsStore(state => state.isLoading);
  const goalsError = useGoalsStore(state => state.error);
  const fetchGoals = useGoalsStore(state => state.fetchGoals);

  const fetchGroupData = useGroupStore(state => state.fetchGroup);

  useEffect(() => {
    updateBalance();
    fetchGoals();
    fetchGroupData();
  }, [updateBalance, fetchGoals, fetchGroupData]);

  return (
    <Container className="pt-3 pb-5">
      <Row>
        <Col xs={12}>
          <UserPageHeader showLanguageSwitcher />
          {isLoading && (
            <div className="text-center py-5">
              <Spinner animation="border" variant="light" role="status">
                <span className="visually-hidden">{t('common.loading')}</span>
              </Spinner>
            </div>
          )}

          {error && (
            <Alert variant="danger" role="alert">
              {error}
            </Alert>
          )}

          {!isLoading && !error && (
            <>
              <Balance value={balance} />
              <GoalsSection
                goals={goals}
                isLoading={goalsLoading}
                error={goalsError}
              />
            </>
          )}
        </Col>
      </Row>
      <BottomNavigationBar />
    </Container>
  );
}
